import React from 'react';
import ChangeDates from '../../../assets/Service-icon/Change Dates.svg';
import DestinationWeddings from '../../../assets/Service-icon/Destination Weddings.svg';
import ConferenceManagement from '../../../assets/Service-icon/Conference Management Services.svg';
import EventPlanning from '../../../assets/Service-icon/Event Planning.svg';

const Benefits = () => {
  const options = [
    {
      id: 1,
      img: ChangeDates,
      title: 'Change Dates',
    },
    {
      id: 2,
      img: DestinationWeddings,
      title: 'Destination Weddings',
    },
    {
      id: 3,
      img: ConferenceManagement,
      title: 'Conference Management Services',
    },
    {
      id: 4,
      img: EventPlanning,
      title: 'Event Planning & Themes',
    },
  ];

  return (
    <div className='px-4 py-10 text-center'>
      {/* Main Heading */}
      <h1 className='mb-12 text-3xl font-extrabold leading-snug text-gray-900 md:text-6xl'>
        Benefits Of Flights Ticketing.
      </h1>

      {/* Grid */}
      <div className='mx-auto grid max-w-7xl grid-cols-1 gap-8 md:grid-cols-4'>
        {options.map((item) => (
          <div
            key={item.id}
            className='service_card flex flex-col items-center rounded-lg'
          >
            <img
              src={item.img}
              alt={item.title}
              className='mb-4 h-24 w-24 object-contain'
            />
            <h3 className='text-dark mb-2 text-xl font-semibold md:text-2xl'>{item.title}</h3>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Benefits;
